export default __webpack_public_path__ + "static/media/person.ef536482.svg";